import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'delete'

export default class OspreyImagesTagsRemove extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425b0'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeTagFromImage(params) {
        const { imageId, tagId } = params

        this.path = `/${resource}/${imageId}/tags/${tagId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-tags-remove.js